import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import '../styles/ViewJobCards.css';
import HeaderMenu from '../components/HeaderMenu';

// 👇 استدعاء PageWrapper
import PageWrapper from '../components/PageWrapper';

function ViewJobCards() {
  const [jobCards, setJobCards] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [role, setRole] = useState(null);
  const [technicianBranch, setTechnicianBranch] = useState(null); // 👈 مضاف لتخزين فرع التكنشن
  const navigate = useNavigate();

  useEffect(() => {
    const fetchJobCards = async () => {
      const querySnapshot = await getDocs(collection(db, 'jobCards'));
      const cards = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setJobCards(cards);
    };

    const currentRole = localStorage.getItem('userRole');
    const branch = localStorage.getItem('technicianBranch'); // 👈 استرجاع فرع التكنشن
    setRole(currentRole);
    setTechnicianBranch(branch); // 👈 تخزينه في state
    fetchJobCards();
  }, []);

  // 👇 تعديل فلترة النتائج لتشمل الفرع فقط إذا كان المستخدم تكنشن
  const filteredCards = jobCards.filter(card => {
    const fullName = `${card.firstName || ''} ${card.lastName || ''}`.toLowerCase();

    const matchSearch =
      fullName.includes(searchTerm.toLowerCase()) ||
      (card.serial && card.serial.toLowerCase().includes(searchTerm.toLowerCase()));

    if (role === 'technician' && technicianBranch) {
      return matchSearch && card.branch === technicianBranch; // 👈 فلترة حسب الفرع
    }

    return matchSearch; // 👈 باقي الأدوار يشوفوا الكل
  });

  return (
    <PageWrapper>
      <div className="viewjob-container">
        <HeaderMenu />
        <h1 className="viewjob-title">All Job Cards</h1>

        <input
          type="text"
          placeholder="Search by name or serial number"
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          className="viewjob-search"
        />

        <table className="viewjob-table">
          <thead>
            <tr>
              <th>Serial</th>
              <th>Patient Name</th>
              <th>Age</th>
              <th>Destination</th>
              <th>Lab Branch</th>
              <th>Audiologist</th>
              <th>Technician</th>
              <th>Completed At</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredCards.length > 0 ? (
              filteredCards.map(card => (
                <tr key={card.id}>
                  <td>{card.serial || 'N/A'}</td>
                  <td>{`${card.firstName || ''} ${card.lastName || ''}`}</td>
                  <td>{card.age || 'N/A'}</td>
                  <td>{card.destination || 'N/A'}</td>
                  <td>{card.branch || 'N/A'}</td> {/* 👈 مضاف */}
                  <td>{card.audiologistName || 'N/A'}</td>
                  <td>{card.technicianName || 'N/A'}</td>
                  <td>{card.completedAt ? new Date(card.completedAt).toLocaleString() : '—'}</td>
                  <td>
                    <button className="action-btn" onClick={() => navigate(`/track/${card.id}`)}>View Job Card</button>
                    {role === 'audiology' && (
                      <button className="action-btn edit" onClick={() => navigate(`/edit-job-card/${card.id}`)}>Edit</button>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="no-results">No Job Cards Found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </PageWrapper>
  );
}

export default ViewJobCards;